import { Flame, CheckCircle2, Target } from 'lucide-react';
import { useRepStreaks } from '@/data/hooks/useRepStreaks';
import { useDealershipData } from '@/data/hooks/useDealershipData';
import { useAuth } from '@/contexts/AuthContext';

export function StreakChips() {
  const { streaks } = useRepStreaks();
  const { mode, userId } = useAuth();
  const { deals } = useDealershipData();
  const repId = mode === 'demo' ? 'rep-alex' : userId;
  const withNextStep = deals.filter(
    (d) => d.rep_id === repId && d.stage !== 'sold' && !!d.next_step,
  ).length;

  const chips = [
    { icon: Flame, value: streaks.current_streak, label: 'day streak', color: 'text-orange-400' },
    { icon: CheckCircle2, value: streaks.followups_today, label: 'follow-ups today', color: 'text-green-400' },
    { icon: Target, value: withNextStep, label: 'with next step', color: 'text-primary' },
  ];

  return (
    <div className="grid grid-cols-3 gap-2">
      {chips.map((c, i) => {
        const Icon = c.icon;
        return (
          <div key={i} className="flex items-center gap-1.5 px-2 py-1.5 rounded-md bg-muted/40 border border-border">
            <Icon className={`h-3.5 w-3.5 ${c.color}`} />
            <span className="text-sm font-bold tabular-nums">{c.value}</span>
            <span className="text-[10px] text-muted-foreground leading-tight">{c.label}</span>
          </div>
        );
      })}
    </div>
  );
}